module.exports = __webpack_public_path__ + "img/spin_btn.b6cd22e4.png";